import React from 'react';
import { Box, Typography } from '@mui/material';
// CONSTANTS
import { TP_COLORS } from '../../../../constants';
import { getAppName } from '../../../../helper';

export interface IImageContainer {
  type: 'question' | 'quiz';
}

const ImageContainer: React.FC<IImageContainer> = ({ type }) => {
  return (
    <div
      style={{
        marginBottom: '30px',
        padding: '0 5%',
        background: 'linear-gradient(264deg, #4DE6B3, #65CFCD)',
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        style={{
          background: `url('${process.env.PUBLIC_URL}/images/shapes/colored-3d-boxes.svg') bottom left/20% no-repeat, url('${process.env.PUBLIC_URL}/images/shapes/jigsaw-puzzle-items.svg') top right/30% no-repeat`,
          padding: '15px',
          minHeight: '180px',
        }}
      >
        <Typography
          variant="h4"
          sx={{ color: TP_COLORS.white }}
          fontWeight={600}
        >
          {getAppName()} Learning Platform
        </Typography>
        <Typography variant="h5" sx={{ color: TP_COLORS.white }}>
          {type === 'question' ? 'Question Bank' : 'Quiz'}
        </Typography>
      </Box>
    </div>
  );
};

export default ImageContainer;
